import ContentTypes from "./ContentTypes";
import AnalyticsEventContent from "./AnalyticsEventContent";
import MovieContent from "./MovieContent";
import SetVariableContent from "./SetVariableContent";
import TextContent from "./TextContent";
import AudioContent from "./AudioContent";
import DialogContentComponent from "./DialogContentComponent";
import AppointmentContent from "./AppointmentContent";
import ImageContent from "./ImageContent";
import OverlayImageContent from "./dialog/OverlayImageContent";
import File from "./File";
import KeyMomentChoiceContent from "./KeyMomentChoiceContent";
import ConversationTopicContent from "./dialog/ConversationTopicContent";
import FeedbackContent from "./FeedbackContent";
import MinigameContent from "./MinigameContent";
import NPCContent from "./NPCContent";
import GiveItemContent from "./dialog/GiveItemContent";
import VoiceMailContent from "./VoiceMailContent";
import DraftEmailContent from "./DraftEmailContent";
import PhonecallContent from "./PhonecallContent";
import EMailContent from "./EMailContent";
import QuizContentComponent from "./QuizContentComponent";
import QuizAnswerContent from "./QuizAnswerContent";
import QuizAnswerImageContent from "./QuizAnswerImageContent";
import QuizAnswerScaleContent from "./QuizAnswerScaleContent";
import QuizAnswerSubmitContent from "./QuizAnswerSubmitContent";
import VariableMutationNumberContent from "./VariableMutationNumberContent";
import NarrativeEventContent from "./NarrativeEventContent";
import ObjectContent from "./ObjectContent";
import MeetingNotesContent from "./MeetingNotesContent";
import MapMutationContent from "./MapMutationContent";
import TransitionContent from "./TransitionContent";
import ChangeEntityVisibilityContent from "./ChangeEntityVisibilityContent";
import UnlockLocationContent from "./UnlockLocationContent";
import { isNull } from "../../util/TypeUtil";
import SMSContent from "./SMSContent";
import MCBlock from "./MCBlock";
import DecisionContent from "./DecisionContent";
import ChatContent from "./ChatContent";
import TaskContent from "./TaskContent";
import ChatMessageContent from "./ChatMessageContent";

export default class ContentFactory {

    static getContent(type, languagePack) {
        var content;

        switch (type) {
            case ContentTypes.TYPE_ANALYTICS_EVENT:
                content = new AnalyticsEventContent(languagePack);
                break;
            case ContentTypes.TYPE_TEXT:
                content = new TextContent(languagePack);
                break;
            case ContentTypes.TYPE_AUDIO:
                content = new AudioContent(languagePack);
                break;
            case ContentTypes.TYPE_SET_VARIABLE:
                content = new SetVariableContent(languagePack);
                break;

            case ContentTypes.TYPE_MOVIE:
                content = new MovieContent(languagePack);
                break;

            case ContentTypes.TYPE_DIALOG:
                content = new DialogContentComponent(languagePack);
                break;
            case ContentTypes.TYPE_DECISION:
                content = new DecisionContent(languagePack);
                break;
            case ContentTypes.TYPE_CHAT:
                content = new ChatContent(languagePack);
                break;
            case ContentTypes.TYPE_CHAT_MESSAGE:
                content = new ChatMessageContent(languagePack);
                break;

            case ContentTypes.TYPE_IMAGE:
                content = new ImageContent(languagePack);
                break;
            case ContentTypes.TYPE_OVERLAY_IMAGE:
                content = new OverlayImageContent(languagePack);
                break;
            case ContentTypes.TYPE_FILE:
                content = new File(languagePack);
                break;

            case ContentTypes.TYPE_KEY_MOMENT_CHOICE:
                content = new KeyMomentChoiceContent(languagePack);
                break;

            case ContentTypes.TYPE_CONVERSATION_TOPIC:
                content = new ConversationTopicContent(languagePack);
                break;
            case ContentTypes.TYPE_FEEDBACK:
                content = new FeedbackContent(languagePack);
                break;
            case ContentTypes.TYPE_MINIGAME:
                content = new MinigameContent(languagePack);
                break;
            case ContentTypes.TYPE_NPC:
                content = new NPCContent(languagePack);
                break;
            case ContentTypes.TYPE_GIVE_ITEM:
                content = new GiveItemContent(languagePack);
                break;
            case ContentTypes.TYPE_VOICEMAIL:
                content = new VoiceMailContent(languagePack);
                break;
            case ContentTypes.TYPE_EMAIL_DRAFT:
                content = new DraftEmailContent(languagePack);
                break;
            case ContentTypes.TYPE_MCBLOCK:
                content = new MCBlock(languagePack);
                break;
            case ContentTypes.TYPE_PHONECALL:
                content = new PhonecallContent(languagePack);
                break;
            case ContentTypes.TYPE_EMAIL:
                content = new EMailContent(languagePack);
                break;
            case ContentTypes.TYPE_SMS:
                content = new SMSContent(languagePack);
                break;
            case ContentTypes.TYPE_QUIZ:
                content = new QuizContentComponent(languagePack);
                break;
            case ContentTypes.TYPE_QUIZANSWER:
                content = new QuizAnswerContent(languagePack);
                break;
            case ContentTypes.TYPE_QUIZANSWER_IMAGE:
                content = new QuizAnswerImageContent(languagePack);
                break;
            case ContentTypes.TYPE_QUIZANSWER_SCALE:
                content = new QuizAnswerScaleContent(languagePack);
                break;
            case ContentTypes.TYPE_QUIZANSWER_SUBMIT:
                content = new QuizAnswerSubmitContent(languagePack);
                break;
            case ContentTypes.TYPE_VARIABLE_MUTATION_NUMBER:
                content = new VariableMutationNumberContent(languagePack);
                break;
            case ContentTypes.TYPE_NARRATIVE_EVENT:
                content = new NarrativeEventContent(languagePack);
                break;
            case ContentTypes.TYPE_OBJECT:
                content = new ObjectContent(languagePack);
                break;
            case ContentTypes.TYPE_MEETING_NOTES:
                content = new MeetingNotesContent(languagePack);
                break;
            case ContentTypes.TYPE_MAP_MUTATION:
                content = new MapMutationContent(languagePack);
                break;
            case ContentTypes.TYPE_TRANSITION:
                content = new TransitionContent(languagePack);
                break;
            case ContentTypes.TYPE_APPOINTMENT:
                content = new AppointmentContent(languagePack);
                break;
            case ContentTypes.TYPE_CHANGE_ENTITY_VISIBILITY:
                content = new ChangeEntityVisibilityContent(languagePack);
                break;
            case ContentTypes.TYPE_UNLOCK_LOCATION:
                content = new UnlockLocationContent(languagePack);
                break;
            case ContentTypes.TYPE_TASK:
                content = new TaskContent(languagePack);
                break;

            default:
                console.log("[ContentFactory]", "Content type not implemented: " + type);
                break;
        }

        return content;
    }


    static getContentFromObject(object, languagePack) {
        var content = ContentFactory.getContent(object.type, languagePack);
        if (!isNull(content)) {
            content.setPropertiesFromObject(object);
        }
        return content;
    }

}